// Loading Application
export const loading = ({ app }) => app.loading
export const eventLoading = ({ app }) => app.eventLoading
export const title = ({ app }) => app.title

// User
export const authorized = ({ user }) => user.authorized

// All Fermenters
export const fermenter = ({ fermenters }) => fermenters.active
export const fermenters = ({ fermenters }) => fermenters.all

// All Tank Groups
export const tankGroup = ({ tankGroups }) => tankGroups.active
export const tankGroups = ({ tankGroups }) => tankGroups.all

// Active Site
export const site = ({ sites }) => sites.active
export const sites = ({ sites }) => sites.all

// Settings
export const whatNow = ({ settings }) => settings.whatNow
export const varietals = ({ settings }) => settings.varietals
export const regions = ({ settings }) => settings.regions
export const yeastTypes = ({ settings }) => settings.yeastTypes
export const countries = ({ settings }) => settings.countries

// Simulator Setup
export const simulatorSetup = ({ simulatorSetup }) => simulatorSetup.active

// Ferment Profiles
export const profile = ({ profiles }) => profiles.active
export const profiles = ({ profiles }) => profiles.all

// Ferments
export const ferment = ({ ferments }) => ferments.active
export const ferments = ({ ferments }) => ferments.all
export const graphBase64 = ({ ferments }) => ferments.graphBase64

// Simulator
export const simulatorRunning = ({ simulator }) => simulator.running



// WEBPACK FOOTER //
// ./src/vuex/getters.js